import { type LucideIcon } from 'lucide-react'

interface StatCardProps {
  label?: string
  title?: string
  value: string | number
  icon?: LucideIcon
  trend?: {
    value: string
    direction: 'up' | 'down'
  }
  description?: string
  subtitle?: string
}

export function StatCard({ label, title, value, icon: Icon, trend, description, subtitle }: StatCardProps) {
  // Support both 'title' and 'label', 'subtitle' and 'description'
  const displayLabel = title || label || ''
  const displayDescription = subtitle || description

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-sm text-muted-foreground mb-1">{displayLabel}</p>
          <h3 className="text-3xl font-bold text-foreground">{value}</h3>
          {displayDescription && <p className="text-xs text-muted-foreground mt-1">{displayDescription}</p>}
        </div>
        {Icon && <Icon size={24} className="text-primary opacity-60" />}
      </div>
      {trend && (
        <div className={`text-sm font-medium ${trend.direction === 'up' ? 'text-green-400' : 'text-red-400'}`}>
          {trend.direction === 'up' ? '↑' : '↓'} {trend.value}
        </div>
      )}
    </div>
  )
}
